var map = {
	"./template.bet575": 1699,
	"./template.bet575.tsx": 1699,
	"./template.bet777": 1700,
	"./template.bet777.tsx": 1700,
	"./template.betgalaxy": 1701,
	"./template.betgalaxy.tsx": 1701,
	"./template.betprofessor": 2152,
	"./template.betprofessor.tsx": 2152,
	"./template.betroyale": 1702,
	"./template.betroyale.tsx": 1702,
	"./template.betstride": 1703,
	"./template.betstride.tsx": 1703,
	"./template.chromabet": 1704,
	"./template.chromabet.tsx": 1704,
	"./template.default": 678,
	"./template.default.tsx": 678,
	"./template.epicodds": 1705,
	"./template.epicodds.tsx": 1705,
	"./template.fiestabet": 2153,
	"./template.fiestabet.tsx": 2153,
	"./template.forsport": 1706,
	"./template.forsport.tsx": 1706,
	"./template.gigabet": 2154,
	"./template.gigabet.tsx": 2154,
	"./template.goldenbet888": 2155,
	"./template.goldenbet888.tsx": 2155,
	"./template.goldenrush": 2156,
	"./template.goldenrush.tsx": 2156,
	"./template.hyperbet": 2157,
	"./template.hyperbet.tsx": 2157,
	"./template.juicybet": 1707,
	"./template.juicybet.tsx": 1707,
	"./template.junglebet": 1708,
	"./template.junglebet.tsx": 1708,
	"./template.magnumbet": 1709,
	"./template.magnumbet.tsx": 1709,
	"./template.oldgill": 2158,
	"./template.oldgill.tsx": 2158,
	"./template.puntcity": 1710,
	"./template.puntcity.tsx": 1710,
	"./template.puntgenie": 1711,
	"./template.puntgenie.tsx": 1711,
	"./template.pyramidbet": 1712,
	"./template.pyramidbet.tsx": 1712,
	"./template.questbet": 2159,
	"./template.questbet.tsx": 2159,
	"./template.slambet": 2160,
	"./template.slambet.tsx": 2160,
	"./template.sterlingparker": 2161,
	"./template.sterlingparker.tsx": 2161,
	"./template.sugarcastle": 1713,
	"./template.sugarcastle.tsx": 1713,
	"./template.templebet": 1714,
	"./template.templebet.tsx": 1714,
	"./template.titanbet": 2162,
	"./template.titanbet.tsx": 2162,
	"./template.ts": 990,
	"./template.vikingbet": 1715,
	"./template.vikingbet.tsx": 1715,
	"./template.volcanobet": 1716,
	"./template.volcanobet.tsx": 1716,
	"./template.wellbet": 2163,
	"./template.wellbet.tsx": 2163
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2475;